module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/innovation_announcements/hareket2-a8f912f11fa5839028e08040bccd919f.jpg";